import ModalSubmitReview from './ModalSubmitReview';

export default ModalSubmitReview;
